/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import toFixed from '../../utils/numericUtils';

import './DiagnosticsOrderSuccess.scss';

const DiagnosticsOrderSuccess = ({ orderDetails }) => (
  <div>
    {isEmpty(orderDetails) ? <div>Order Placed</div> : <div className="mainContainer">
      <div className="titleImg">
        <img src={require('../../images/heart.svg')} alt="order success" />
      </div>
      <div className="orderCardStatus">{orderDetails.current_status.name} - <span className="titleText">Appointment Scheduled Successfully</span></div>
      <div className="diagnosticsOrderCard">
        <div className="orderCardImg">
          <img src={require('../../images/labtest.svg')} alt="tt" />
        </div>
        <div className="orderCardTextContainer">
          <div className="orderCardHeader">
            <div className="orderCardPatientName">Patient name: {orderDetails.patient_details.name}</div>
            <a
              href={`https://diagnostics.private.pharmeasy.in/order-details/${orderDetails.order_id}`}
              target="_blank"
              className="orderCardPatientName"
            >
              Order ID: {orderDetails.pe_order_id}
            </a>
            <div className="orderCardPrice">&#8377;{toFixed(orderDetails.fare_details.total_payable_amount, 2)}</div>
          </div>
          <div className="orderCardLab">Lab: {orderDetails.lab_details.item_name}</div>
          <div className="orderCardTests">Tests booked: {orderDetails.test_details.map((test, index) => <div key={test.dos_id}>{index + 1}. {test.item_name}</div>)}</div>
          <div className="orderCardFooter">
            <div className="orderCardEDD">Appointment Date: {moment(orderDetails.slot_details.pickup_date).format('DD MMMM, dddd')}</div>
            <div className="orderCardEDD">Appointment Time: {orderDetails.slot_details.slot_time}</div>
          </div>
        </div>
      </div>
    </div>}
  </div>
);

DiagnosticsOrderSuccess.propTypes = {
  orderDetails: PropTypes.object,
};

DiagnosticsOrderSuccess.defaultProps = {
  orderDetails: {},
};

export default DiagnosticsOrderSuccess;
